import React from "react";
import styles from "./DossierDashboard.module.scss";

const QualityChecks = ({ stats, onScrollTo }) => (
  <div className={styles.sect}>
    <div className={styles.sectTitle}>
      <span>
        {stats.issues.length > 0
          ? "À corriger avant validation"
          : "Complétude"}
      </span>
    </div>
    {stats.issues.length > 0 && (
      <div className={styles.alertBox}>
        {stats.issues.map((issue, i) => (
          <button
            key={i}
            type="button"
            className={styles.alertRow}
            onClick={() => onScrollTo(issue.index)}
            title="Aller au devis"
          >
            <span>
              <i className="fa fa-exclamation-triangle mr-1" />
              {issue.reference} — {issue.label}
            </span>
            <i className="fa fa-arrow-right" />
          </button>
        ))}
      </div>
    )}
    {stats.readyCount > 0 && (
      <div className={styles.okBox}>
        <i className="fa fa-check mr-1" />
        {stats.readyCount} devis complet{stats.readyCount > 1 ? "s" : ""}
        {stats.issues.length === 0 ? ", rien à corriger" : ""}
      </div>
    )}
  </div>
);

export default QualityChecks;
